<template>
	<div id="map" class="map">
		<TMap :bounds="bounds">
			<map-areas
				visible
				:areas="searchAreas"
				:polygonOptions="{ color: '#735dd0', opacity: 0.4, fillColor: '#ffffff', fillOpacity: 0.2, interactive: false }"
			/>
			<map-areas
				visible
				:areas="unexpandedAreas"
				:polygonOptions="{ color: '#cfd8dc', opacity: 1, fillColor: '#ffffff', fillOpacity: 0, interactive: false }"
			/>
			<leaflet-marker
				v-for="(marker) of validTerminals"
				:ref="marker.id"
				:key="marker.id"
				:latitude="marker.latitude"
				:longitude="marker.longitude"
				:icon="terminalIcon"
				:markerOptions="markerOptions"
				preventRefreshMarkersOnMoveMap
			/>
		</TMap>
	</div>
</template>

<script>
import 'leaflet/dist/leaflet.css'; // necessary CSS dependency
import MapAreas from './MapAreas.vue';
import L from 'leaflet';
import createIconMixin from '@/components/map/CreateIcon.mixin.js';

export default {
	name:'LocationsDialogMap',
	components: { MapAreas },
	mixins: [createIconMixin],
	props:{
		mapAreas: Array,
		dialogReady: Boolean,
		terminals: Array
	},
	data() {
		return {
			map: null,
			dialogArea: null,
			polygonOptions: { color: '#735dd0' },
			bounds: null,
			validTerminals: [],
			terminalIcon: null,
			markerOptions: {
				interactive: false
			}
		};
	},
	computed: {
		searchAreas() {
			return this.mapAreas.map(x => ({ id: x.id, area: x.expanded ? x.expanded : x.area }) );
		},
		unexpandedAreas() {
			return this.mapAreas.filter(x => Boolean(x.expanded));
		}
	},
	mounted() {
		//this.map = new L.map('map', {
		//	center: [ 63.00,10.00 ],
		//	zoom: 4,
		//	zoomControl: false,
		//	worldCopyJump: true
		//});
		let areas = new L.featureGroup();
		this.mapAreas.forEach(polygon => {
			new L.geoJSON(polygon.expanded ? polygon.expanded : polygon.area).addTo( areas );
		});
		this.bounds = areas.getBounds();

		this.terminalIcon = this.createIcon({
			iconName: 'office',
			iconType: 'bp',
		});
		this.setupTerminalPoints();
	},
	methods: {
		setupTerminalPoints() {
			let points = [];

			this.terminals.forEach(item => {
				if (item.latitude && item.longitude) {
					points.push({
						id: item.id,
						latitude: item.latitude,
						longitude: item.longitude,
					});
				}
			});

			this.validTerminals = Object.freeze(points);
		},
	}
};
</script>

<style scoped>
.map {
	display: flex;
	box-sizing: border-box;
	display: block;
	width: 100%;
	height: 100%;
}
</style>
